export default __webpack_public_path__ + "static/media/coursera~yBYOZOwL.25bfc990.svg";